var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"layout":"column"}},[_c('vue-snotify'),_c('router-view',{attrs:{"name":"top"}}),_c('div',{staticClass:"body-container",attrs:{"layout":"row","flex":""}},[_c('router-view',{attrs:{"name":"body","flex":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }